
// Infinity-scroll for non-slider gallery blocks.
// Each block has its own trigger/loader keyed by block id, so several gallery
// blocks on one page load independently.
document.addEventListener('livewire:init', () => {
    const triggers = document.querySelectorAll('[data-ref^="trigger.infinity_scroll.gallery."]');
    if (!triggers.length) return;

    triggers.forEach((trigger) => {
        const blockId = Number(trigger.getAttribute('data-ref').split('.').pop());
        const loader = document.querySelector(`[data-ref="infinity-scroll-loader.gallery.${blockId}"]`);
        let isLoading = false;

        const loadNext = () => {
            if (isLoading) return;
            isLoading = true;
            if (loader) loader.style.display = '';
            Livewire.dispatch('uploadGallery', { blockId });
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) loadNext();
            });
        }, { rootMargin: '500px' });

        observer.observe(trigger);

        Livewire.on('galleryLoaded', (payload) => {
            if (Number(payload.blockId) !== blockId) return;

            isLoading = false;
            if (loader) loader.style.display = 'none';

            if (payload.html && loader) {
                loader.insertAdjacentHTML('beforebegin', payload.html);
            }

            if (payload.finished) {
                observer.disconnect();
                return;
            }

            const rect = trigger.getBoundingClientRect();
            if (rect.top < window.innerHeight + 500) {
                loadNext();
            }
        });
    });
});